"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;
exports.getName = getName;
exports.getVersion = getVersion;
exports.isSafari = isSafari;
var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Module that provides utility functions for browser detection.
 *
 * @module browser
 */

var parser = new _uaParserJs["default"]();
var _parser$getBrowser = parser.getBrowser(),
  name = _parser$getBrowser.name,
  version = _parser$getBrowser.version;

/**
 * Check whether the browser is Safari.
 * @return {boolean} Whether the browser is Safari or not
 */
function isSafari() {
  return name === 'Safari';
}

/**
 * Get the browser version
 * @return {number} The browser version with one decimal space.
 */
function getVersion() {
  return version;
}

/**
 * Get the browser name
 * @return {string} The browser name.
 */
function getName() {
  return name;
}
function getLocation() {
  return window.location;
}